// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".insta-note[data-v-2f408111]{color:#d3d3d3}a[data-v-2f408111]:not(.button){text-decoration:underline}#paper-canvas[data-v-2f408111]{background:#1b1b1b;border-radius:10px}.fill-height[data-v-2f408111]{flex:1 1 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
